import React from "react";
import SharedPostsAnalytics from "./SharedPostsAnalytics";

export default function PMAnalytics({ token, isDarkMode = false }) {
  return <SharedPostsAnalytics token={token} isDarkMode={isDarkMode} />;
}
